import {
  Activity as TActivity,
  Activity,
  ActivityFragmentFragment,
  ActivityTeaserFragmentFragment,
  Hotel,
  ParagraphActivityTabData,
} from '../generated/types';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useMemo } from 'react';

export default function useActivityHotelActivitiesForCategory(
  data: ActivityFragmentFragment
) {
  return useMemo(() => {
    if (data.hotels && data.hotels.items) {
      return data.hotels.items.reduce<{
        category: Array<TActivity | ActivityTeaserFragmentFragment>;
        other: Array<TActivity | ActivityTeaserFragmentFragment>;
      }>(
        (val, curr) => {
          const activitiesForCategory = curr!.activities!.filter(
            (activity) => activity.category!.id === data.category!.id
          );
          const activitiesOtherCategory = curr!.activities!.filter(
            (activity) => activity.category!.id !== data.category!.id
          );

          val.category = val.category.concat(
            activitiesForCategory.filter((activity) => activity.id !== data.id)
          );
          val.other = val.other.concat(
            activitiesOtherCategory.filter(
              (activity) => activity.id !== data.id
            )
          );

          return val;
        },
        {
          category: [],
          other: [],
        }
      );
    }

    return {
      category: [],
      other: [],
    };
  }, [data]);
}
